<template>
   <div class="row">
    <div class="top-bar vd-top-bar">
      <a href="#cameraModal" @click="item = {}, cameraModalAction='add'" data-toggle="modal" data-target="#cameraModal" class="btn-add-new-camera ml-auto">
        <span class="_text">Add New Camera &nbsp;</span>
        <span class="k-light-blue add-plus">+</span>
      </a>
    </div>

    <div class="container-main right-container-video">
      <!-- ATTENDANCE TRACKING SMALL -->
      <div class="vd-attendance-tracking cam-attendance-tracking">
        <div class="row vd-logs-top">
          <p>Locations</p>
          <a href="#locationModal" @click="item = {}, locationModalAction='add'" data-toggle="modal" data-target="#locationModal" class="float-right btn-add-location">
            <span class="float-left">Add</span>
            <span class="k-light-blue add-plus">+</span>
          </a>
        </div>
        <div class="locations-filter-container">
          <search-filter @search="filterLocations($event)"/>
        </div>
        <div class="row attendance-tracking-small" id="items-container">
          <a href="#" @click.prevent="filterCameras(-1)" class="btn-all-locations k-light-blue">All</a>
          <a class="vd-item-link" v-for="location in locations" :key="location.id" @click="filterCameras(location.id)">
            <div class="row item vd-item" v-bind:class="{'active-item': location.id == selectedLocationId }">
              <div class="col-md-4 avatar avatar-small">
                <img src=".././assets/images/camera-icon.png" class="identified-border" alt="" >
              </div>
              <div class="col-md-8 vd-person-data">
                <p class='identified-status vd-identified'>
                  {{ location.name }}
                </p><br>
                <p>ID: {{ location.id }}</p>
                <a href="#locationModal" @click="item = location, locationModalAction='edit'" data-toggle="modal" data-target="#locationModal" class="locations-action locations-edit-item"><img src=".././assets/images/edit.svg" alt="" height="30px" width="30px"></a>
                <a href="#" class="locations-action locations-delete-item" @click.prevent="deleteLocation(location.id)"><img src=".././assets/images/trash.svg" alt="" height="30px" width="30px"></a>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div class="container-main right-container-video right-container-cams">
      <div class="cams-container">
        <div class="camera-card" v-for="(camera, index) in cameras" :key="index">
          <div class="row first-two-footage cam-double-images text-center mx-auto">
            <div class="footage-labels">
              <p>HD</p>
              <!-- <p><img src=".././assets/images/Thermo .svg" alt=""></p> -->
            </div>
            <div class="col">
              <img style="-webkit-user-select: none;" :src="`${camera.path}`">
              <!-- <img src=".././assets/images/edit.svg" alt=""> -->
            </div>
            <!-- <div class="col">
              <img style="-webkit-user-select: none;" :src="`${camera.path}/thermal`">
            </div> -->
          </div>
          <div class="row row-padded">
            <div class="col border-right">
              <p class="cam-p">ID:</p>
              <p class="cam-p cam-p-data">{{ camera.id }}</p><br>
              <p class="cam-p">Type:</p>
              <p class="cam-p cam-p-data">d sadas</p>
            </div>
            <div class="col">
              <p class="cam-p">ID:</p>
              <p class="cam-p cam-p-data">{{ camera.id }}</p><br>
              <p class="cam-p">Type:</p>
              <p class="cam-p cam-p-data">dsads</p>
            </div>
          </div>
          <div class="row row-padded">
            <div class="col">
              <p class="cam-p">Name:</p>
              <p class="cam-p cam-p-data">{{ camera.name }}</p><br>
              <p class="cam-p">Associated location:</p>
              <p class="cam-p cam-p-data">{{ camera.location.name }}</p>
            </div>
          </div>
          <div class="row camera-buttons">
            <a @click="item = camera, cameraModalAction='edit'" data-toggle="modal" data-target="#cameraModal" class="col btn-camera">
              <img src=".././assets/images/edit.svg" alt="" height="16px" width="16px">&nbsp;Edit
            </a>
            <a @click.prevent="deleteCamera(camera.id)" class="col btn-camera">
              <img src=".././assets/images/trash.svg" alt="" height="16px" width="16px">&nbsp;Delete
            </a>
          </div>
        </div>
      </div>
    </div>

    <location-modal :item='item' :action='locationModalAction' @locations-changed='getLocations()' @snotify='snotify($event)'/>
    <camera-modal :item='item' :action='cameraModalAction' :locations='locations'  @cameras-changed='getCameras()'  @snotify='snotify($event)'/>
  </div>
</template>

<script>
  import SearchFilter from '@/components/filters/Search';
  import LocationModal from '@/components/LocationModal';
  import CameraModal from '@/components/CameraModal';
  // data/webcam3.mp4
  export default {
    name: 'CameraSettings',
    components: {
      SearchFilter,
      LocationModal,
      CameraModal,
    },
    data() {
      return {
        locations: {},
        cameras: {},
        unfilteredCameras: {},
        item: {},
        locationModalAction: '',
        cameraModalAction: '',
        selectedLocationId: '',
      };
    },
    computed: {
      url() {
        return this.axios.defaults.baseURL;
      },
    },
    mounted() {
      this.getLocations();
      this.getCameras();
    },
    methods: {
      setItem(item) {
        this.item = item;
      },
      getLocations() {
        this.axios.get('/locations')
          .then(response => {
            this.locations = response.data.locations;
          });
      },
      getCameras() {
        let data = {
          camera_id: 1,
          start: 0,
          limit: 10,
        };

        this.axios.get(`/cameras`, { params: data })
          .then((response) => {
              this.cameras = response.data.cameras;
              this.unfilteredCameras = this.cameras;
          });
      },
      deleteLocation(locationId) {
        if(confirm('Are you sure you want to delete this location?'))
        {
          let data = new FormData();

          data.set('location_id', locationId);

          this.axios.delete(`/location`, { data: data })
            .then(() => {
              this.getLocations();
              this.snotify({status: 'success', message: 'Location successfully deleted.'});
            });
        }
      },
      deleteCamera(cameraId) {
        if(confirm('Are you sure you want to delete this camera?'))
        {
          let data = new FormData();

          data.set('camera_id', cameraId);

          this.axios.delete(`/camera`, { data: data })
            .then(() => {
              this.getCameras();
              this.snotify({status: 'success', message: 'Camera successfully deleted.'});
            });
        }
      },
      filterCameras(locationId) {
        this.selectedLocationId = locationId;
        if(locationId == -1) {
          this.cameras = this.unfilteredCameras;
        }
        else {
          this.cameras = this.unfilteredCameras.filter(function(item) {
            return item.location_id == locationId;
          });
        }
      },
      filterLocations(query) {
        this.axios.get(`/locations?query=${query}`)
          .then(response => {
            this.locations = response.data.locations;
          });
      },
      snotify(state) {
        this.$snotify[state.status](state.message);
      },
    },
  };
</script>

<style scoped>
  #items-container {
    overflow-y: scroll !important;
  }
</style>
